import { render, staticRenderFns } from "./commentFilter.vue?vue&type=template&id=9c8b9756&scoped=true&"
import script from "./commentFilter.vue?vue&type=script&lang=js&"
export * from "./commentFilter.vue?vue&type=script&lang=js&"
import style0 from "./commentFilter.vue?vue&type=style&index=0&id=9c8b9756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8b9756",
  null
  
)

export default component.exports